import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type AppEnvironment =
  | 'development'
  | 'test'
  | 'production';

export interface EnvironmentStatus {
  environment: AppEnvironment;
  is_development: boolean;
  is_production: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentStatusService {
  private readonly http = inject(HttpClient);

  // Prilagodi ako se API URL konfigurira na drugi način.
  private readonly apiUrl = '/api/v1';

  getEnvironment(): Observable<EnvironmentStatus> {
    return this.http.get<EnvironmentStatus>(
      `${this.apiUrl}/environment`,
    );
  }
}